export const personalOrderMakePathText =
  'После авторизации товары, которые вы добавили, останутся в корзине';
export const goodsPathText =
  'Войдите, чтобы мы могли отправить уведомление, когда товар появится';
